document.addEventListener('DOMContentLoaded', function () {
  var root = document.documentElement;
  var lastTrigger = null;

  function openDrawer(el, trigger) {
    if (!el) { return; }
    lastTrigger = trigger || null;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    root.classList.add('drawer-locked');
    if (trigger) { trigger.setAttribute('aria-expanded', 'true'); }
    var close = el.querySelector('.drawer-close');
    if (close) { setTimeout(function () { close.focus({ preventScroll: true }); }, 50); }
  }

  function closeDrawer(el) {
    if (!el || !el.classList.contains('is-open')) { return; }
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('[data-drawer].is-open')) { root.classList.remove('drawer-locked'); }
    document.querySelectorAll('[data-menu-toggle]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    if (lastTrigger) { try { lastTrigger.focus({ preventScroll: true }); } catch (e) {} lastTrigger = null; }
  }

  document.querySelectorAll('[data-drawer]').forEach(function (drawer) {
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { closeDrawer(drawer); });
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { document.querySelectorAll('[data-drawer].is-open').forEach(closeDrawer); }
  });

  // ---------- Menu ----------
  var menuDrawer = document.querySelector('[data-mobile-menu]');
  document.querySelectorAll('[data-menu-toggle]').forEach(function (toggle) {
    toggle.addEventListener('click', function () { openDrawer(menuDrawer, toggle); });
  });

  // ---------- Cart drawer ----------
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  if (!cartDrawer) { return; }
  var itemsEl = cartDrawer.querySelector('[data-cart-items]');
  var subtotalEl = cartDrawer.querySelector('[data-cart-subtotal]');
  var footEl = cartDrawer.querySelector('[data-cart-foot]');
  var noticeEl = cartDrawer.querySelector('[data-cart-notice]');
  var shipEl = cartDrawer.querySelector('[data-cart-ship]');
  // Sinds 03-10-2026: verzending binnen de EU altijd gratis (geen drempel meer).
  var FREE_SHIPPING_COUNTRIES = ['NL', 'SE', 'DK', 'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DE', 'EE', 'FI', 'FR', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES'];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents, currency) {
    try {
      return (cents / 100).toLocaleString('nl-NL', { style: 'currency', currency: currency || 'EUR' });
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + (currency || '');
    }
  }

  function showNotice(text, isError) {
    if (!noticeEl) { return; }
    noticeEl.textContent = text || '';
    noticeEl.classList.toggle('is-visible', !!text);
    noticeEl.classList.toggle('is-error', !!isError);
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
  }

  function renderShipping(cart) {
    if (!shipEl) { return; }
    var country = window.Shopify && window.Shopify.country;
    if (!cart.item_count || (country && FREE_SHIPPING_COUNTRIES.indexOf(country) === -1)) {
      shipEl.setAttribute('hidden', ''); return;
    }
    shipEl.innerHTML = '<span class="cart-ship--free">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M20 6L9 17l-5-5"/></svg>' +
      '<span><strong>Free shipping</strong> within the EU · 30-day returns</span></span>';
    shipEl.removeAttribute('hidden');
  }

  function renderCart(cart) {
    updateCount(cart.item_count);
    renderShipping(cart);
    if (subtotalEl) { subtotalEl.textContent = money(cart.total_price, cart.currency); }
    if (footEl) { footEl.hidden = cart.item_count === 0; }
    if (!cart.item_count) {
      itemsEl.innerHTML = '<div class="cd-empty"><p>Your cart is empty.</p><button type="button" class="btn btn-ghost" data-drawer-close-inline>Continue shopping</button></div>';
      var btn = itemsEl.querySelector('[data-drawer-close-inline]');
      if (btn) { btn.addEventListener('click', function () { closeDrawer(cartDrawer); }); }
      return;
    }
    itemsEl.innerHTML = cart.items.map(function (item, i) {
      var img = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cd-variant">' + esc(item.variant_title) + '</div>' : '';
      return '<div class="cd-item">' +
        (img ? '<a href="' + esc(item.url) + '"><img src="' + esc(img) + '" alt="" width="72" height="72" loading="lazy"></a>' : '<span></span>') +
        '<div><a class="cd-title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' + variant +
          '<div class="cd-qty" aria-label="Quantity">' +
            '<button type="button" data-line="' + (i + 1) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-line="' + (i + 1) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<button type="button" class="cd-remove" data-line="' + (i + 1) + '" data-qty="0">Remove</button>' +
        '</div>' +
        '<div class="cd-price">' + esc(money(item.final_line_price, cart.currency)) + '</div>' +
      '</div>';
    }).join('');
    // "Complete the look" (assets/tc-upsell.js)
    if (window.TCUpsell) { try { window.TCUpsell.render(cart, itemsEl); } catch (e) {} }
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function setBusy(on) { cartDrawer.classList.toggle('is-busy', !!on); }

  itemsEl.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line]');
    if (!btn) { return; }
    setBusy(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(btn.getAttribute('data-line'), 10), quantity: parseInt(btn.getAttribute('data-qty'), 10) })
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, j: j }; });
    }).then(function (res) {
      if (res.ok) { showNotice(''); renderCart(res.j); }
      else { showNotice(res.j.description || res.j.message || 'Sorry, something went wrong.', true); return fetchCart().then(renderCart); }
    }).catch(function () {
      showNotice('Sorry, something went wrong. Please try again.', true);
    }).then(function () { setBusy(false); });
  });

  // Iets toegevoegd vanuit "Complete the look": lade verversen
  document.addEventListener('tc:cart-changed', function (e) {
    var d = (e && e.detail) || {};
    setBusy(true);
    fetchCart().then(function (cart) {
      renderCart(cart);
      showNotice(d.message || '', !!d.error);
      if (itemsEl) { itemsEl.scrollTop = 0; }
    }).catch(function () {}).then(function () { setBusy(false); });
  });

  // Cart icon opens the drawer (on the cart page itself, keep the normal link)
  document.querySelectorAll('[data-cart-open]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      if (document.body.classList.contains('template-cart')) { return; }
      e.preventDefault();
      showNotice('');
      setBusy(true);
      openDrawer(cartDrawer, link);
      fetchCart().then(renderCart).catch(function () { window.location.href = link.href; }).then(function () { setBusy(false); });
    });
  });

  // Add to cart without leaving the page
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) { return; }
    if (e.defaultPrevented) { return; }
    e.preventDefault();
    var submit = form.querySelector('[type="submit"]');
    var wasDisabled = submit ? submit.disabled : false;
    if (submit) { submit.disabled = true; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        return fetchCart().then(function (cart) {
          renderCart(cart);
          if (res.ok) { showNotice('✓ ' + (res.j.product_title || 'Item') + ' was added to your cart'); }
          else { showNotice(res.j.description || res.j.message || 'Sorry, this item could not be added.', true); }
          openDrawer(cartDrawer, submit);
        });
      })
      .catch(function () { HTMLFormElement.prototype.submit.call(form); })
      .then(function () { if (submit) { submit.disabled = wasDisabled; } });
  });
});
